function workOrderReducer(state = [], action) {
    const { type, payload } = action;

    switch(type) {
        case "GET_WORK_ORDER_SUCCESS":
            let work_order = Object.assign({}, payload.workorder[0]);
            return Object.assign({}, state, { work_order });

        case "GET_COMMENTS_SUCCESS":
            let comments = payload.comments.reduce((obj, item) => (obj[item.comment_type] = item.comment, obj) ,{});
            return Object.assign({}, state, { comments });

        case "GET_WORK_ORDER_STEPS_SUCCESS":
            let steps = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { steps });

        case "GET_STEP_HISTORY_SUCCESS":
            let step_history = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { step_history });

        case "GET_PART_HISTORY_SUCCESS":
            let part_history = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { part_history });

        case "SEARCH_PARTS_SUCCESS":
            let part_search = Object.assign([], payload.response.docs);
            return Object.assign({}, state, { part_search });

        case "GET_EQUIPMENT_SUCCESS":
        case "GET_PARTS_SUCCESS":
        case "GET_LABOR_SUCCESS":
            return Object.assign({}, state, { ...payload });

        case "GET_PART_HISTORY_SUCCESS":
            return Object.assign({}, state, {  });

        case "UNSET_WORK_ORDER":
            return Object.assign({}, state, {
                work_order: {},
                equipment: [],
                parts: [],
                labor: [],
                steps: [],
                step_history: [],
                part_history: [],
                comments: {}
            });

        default:
            return state;
    }
}

export default workOrderReducer;